import React from 'react';
import { Inbox01 } from '@untitledui/icons';

import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  title: React.ReactNode;
  message?: React.ReactNode;
  testId?: string;
}

export function EmptyState({ title, message, testId }: EmptyStateProps): React.ReactElement {
  return (
    <div className={styles.empty} data-testid={testId}>
      <span className={styles.icon} aria-hidden="true">
        <Inbox01 width={32} height={32} />
      </span>
      <div className={styles.title}>{title}</div>
      {message ? <div className={styles.message}>{message}</div> : null}
    </div>
  );
}

export default EmptyState;
